import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from "sprout-ui-primitives";
import { themeGet, media } from "sprout-ui-theme";
import { Button } from "sprout-ui-dom/dist/Button";
import styled from "styled-components";
import PostPageCommentReply from "./PostPageCommentReply";
const ViewMoreButton = styled(Button)`
  :not(:disabled) {
    color: ${themeGet("colors.blue.500")};
    ${media.target("pointer")} {
      :hover {
        text-decoration: underline;
      }
    }
  }

  :disabled {
    color: ${themeGet("colors.black.30")};
  }
`;
const StyledBox = styled(Box)`
  > :not(style) {
    position: relative;
  }

  > :not(style):not(:last-child) {
    &::before {
      position: absolute;
      content: "";
      top: 52px;
      left: 33px;
      bottom: 0;
      width: 2px;
      background: ${themeGet("colors.black.12")};
    }
  }
`;
const PostPageCommentReplies = (props)=>{
    const { itemId , replies , loadMore , loading , excessReplyCount , parentCommentNodeId , parentCommentId ,  } = props;
    return /*#__PURE__*/ _jsxs(StyledBox, {
        borderRadius: "24px",
        bg: "blue.50",
        py: 1,
        mt: 3,
        children: [
            replies.map((reply)=>{
                return /*#__PURE__*/ _jsx(PostPageCommentReply, {
                    itemId: itemId,
                    parentCommentNodeId: parentCommentNodeId,
                    parentCommentId: parentCommentId,
                    reply: reply
                }, reply.id);
            }),
            excessReplyCount > 0 && /*#__PURE__*/ _jsx(Box, {
                mt: 2,
                mx: 3,
                children: /*#__PURE__*/ _jsx(ViewMoreButton, {
                    disabled: loading,
                    onClick: ()=>{
                        loadMore();
                    },
                    children: /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        fontSize: "15px",
                        fontWeight: "medium",
                        children: loading ? "Loading more replies..." : "View more"
                    })
                })
            })
        ]
    });
};
export default PostPageCommentReplies;
